import { createMapStopResponse } from './mapBusStopResponse';

export const mapStopResponse = createMapStopResponse();
